<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px"
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-flex xs12>
          <v-card flat tile>
            <v-card-text>
              <!-- <v-form ref="form" @submit.stop v-model="validForm" :disabled="!isDraft"> -->
              <v-form ref="form" @submit.stop v-model="validForm" :disabled="true">
                <v-card flat>
                  <v-card-title>Formular inscriere proiect</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-banner sticky app style="background-color: white">
                      <v-progress-circular v-if="!alert" :value="autoSavePercentage" :color="getProgressColor">
                        <v-icon small color="info">mdi-content-save</v-icon>
                      </v-progress-circular>
                      <span class="caption mx-4" v-if="lastSave && !alert">
                        {{ isDraft ? 'Ultima salvare' : 'Depunere'}}:
                        {{ isDraft ? '' : `Nr. ${user.nrcrt} din `}}
                        {{ new Date(lastSave).toLocaleString("ro-RO") }}
                      </span>
                      <v-btn icon @click="alert = true" v-if="!alert" :loading="loading">
                        <v-icon color="grey">mdi-alert-circle-outline</v-icon>
                      </v-btn>
                      <v-btn color="accent" v-if="isDraft && !alert" @click="autoSave" icon disabled>
                        <v-icon>mdi-content-save</v-icon>
                      </v-btn>
                      <v-alert type="info" border="left" prominent text class="text-justify" dismissible @input="alert = false" :value="alert">
                        <strong class="mb-2" style="display: block">Atentie!</strong>
                        <div :class="{ 'text-caption': $vuetify.breakpoint.name === 'xs' }" style="height: 10vh; overflow-y: auto">
                          Pentru a nu pierde informatiile, formularul se salveaza automat o data pe minut. Puteti reveni oricand pentru a modifica informatiile. <br>
                          Cand considerati ca ati terminat de completat toti pasii, apasati butonul "Depunere". Aceasta operatiune este finala, ulterior nu veti mai putea modifica informatiile. <br>
                          Butonul "Depunere" este disponibil doar in momentul in care toti pasii formularului sunt completati si aveti completate toate detaliile personale.
                          Daca la un pas exista probleme, acest lucru este semnalat printr-un simbol de culoare rosie in stanga pasului <v-icon small color="error">mdi-alert</v-icon>,
                          iar butonul "Depunere" nu poate fi apasat.
                        </div>
                        <v-progress-linear :color="getProgressColor" bottom v-if="alert" :value="autoSavePercentage" class="mt-4"></v-progress-linear>
                        <span class="caption" v-if="lastSave">
                          {{ isDraft ? 'Ultima salvare' : 'Depunere'}}:
                          {{ isDraft ? '' : `Nr. ${user.nrcrt} din `}}
                          {{ new Date(lastSave).toLocaleString("ro-RO") }}
                        </span>
                        <br>
                        <v-btn :class="{ 'text-caption': $vuetify.breakpoint.name === 'xs' }" outlined color="accent" v-if="isDraft" @click="autoSave" :loading="loading" disabled>
                          <span v-if="$vuetify.breakpoint.name === 'xs'">
                            Salveaza draft
                          </span>
                          <span v-else>
                            Salveaza copie in lucru
                          </span>
                        </v-btn>
                      </v-alert>
                    </v-banner>
                    <v-stepper v-model="stepper" vertical>
                      <v-stepper-step
                        id="pasul1"
                        :complete="step1Complete()"
                        step="1"
                        edit-icon="mdi-check"
                        editable
                        :rules="rulesStep1()">
                        Pasul 1
                        <small>Dosarul candidatului</small>
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p style="text-align: justify">Documente necesare</p>
                          <p class="caption" style="text-align: justify">
                            <ul>
                              <li>Cerere tip de inscriere Plan de afaceri, datata si semnata (Anexa 3)</li>
                              <li>Declaratia de eligibilitate participant, datata si semnata (Anexa 4)</li>
                              <li>Cazier judiciar candidat, inclusiv pentru asociati, (daca este cazul) sau Declaratie pe proprie raspundere, datata si semnata</li>
                              <li>Cazier fiscal pentru participant, inclusiv pentru asociati (daca este cazul) sau Declaratie pe proprie raspundere, , datata si semnata</li>
                              <li>CV-ul candiatului (format Europass)</li>
                            </ul>
                          </p>
                        </v-alert>

                        <div style="display: flex; flex-wrap: wrap; justify-content: space-around; align-items: stretch">
                          <template v-for="which in papers.step1">
                            <v-card :key="which.key" style="display: inline-block; position: relative" class="ma-4 pa-0">
                              <v-card-text class="pa-0">
                                <v-card
                                  :key="which.key"
                                  width="200"
                                  style="display: inline-block; position: relative"
                                  class="ma-0"
                                  elevation="0"
                                  :color="drag.step1[which.key]">
                                  <div
                                    style="position: absolute; background-color: transparent; width: 200px; height: 100%; z-index: 1; cursor: pointer"
                                    @click="openFileUpload(`step1-${which.key}`)"
                                    @dragover.prevent
                                    @drop.prevent="addFile($event, 'step1', which.key)"
                                    @dragenter="dragEnter($event, 'step1', which.key)"
                                    @dragleave="dragLeave($event, 'step1', which.key)">
                                  </div>

                                  <div>
                                    <input type="file" style="display: none" :ref="`step1-${which.key}`" @change="addFile($event, 'step1', which.key)">
                                    <v-img
                                      class="white--text align-end"
                                      height="100px"
                                      :src="fields.step1[which.key].file || fields.step1[which.key].saved ? '/img/files_closed.jpg' : '/img/files_box_large.jpg'">
                                    </v-img>
                                    <v-card-subtitle class="text-center">
                                      <span class="font-weight-bold" title="Click sau drag&amp;drop pentru a incarca un fisier">
                                        {{ which.label }}
                                      </span>
                                      <br>
                                      <span class="caption">{{ fields.step1[which.key].name }}</span>
                                    </v-card-subtitle>
                                    <v-divider></v-divider>
                                    <!-- <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn icon :disabled="!fields.step1[which.key].saved" @click="downloadFile('step1', which.key)" title="Descarca fisier">
                                        <v-icon color="primary">
                                          mdi-download
                                        </v-icon>
                                      </v-btn>
                                      <v-spacer></v-spacer>
                                      <span>
                                        {{ (fields.step1[which.key].size / 1000).toFixed(2) }} KB
                                        <v-icon small :color="fields.step1[which.key].saved ? 'primary' : 'grey'" :title="fields.step1[which.key].saved ? 'fisier salvat' : 'fisier nesalvat'">
                                          {{ fields.step1[which.key].saved ? 'mdi-check' : 'mdi-close' }}
                                        </v-icon>
                                      </span>
                                      <v-spacer></v-spacer>
                                      <v-btn @click="removeFile('step1', which.key)" icon :disabled="!isDraft" title="Sterge fisier">
                                        <v-icon color="error">mdi-delete</v-icon>
                                      </v-btn>
                                      <v-spacer></v-spacer>
                                    </v-card-actions> -->
                                  </div>
                                </v-card>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                  <v-btn icon :disabled="!fields.step1[which.key].saved" @click="downloadFile('step1', which.key)" title="Descarca fisier">
                                    <v-icon color="primary">
                                      mdi-download
                                    </v-icon>
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                  <span>
                                    {{ (fields.step1[which.key].size / 1000).toFixed(2) }} KB
                                    <v-icon small :color="fields.step1[which.key].saved ? 'primary' : 'grey'" :title="fields.step1[which.key].saved ? 'fisier salvat' : 'fisier nesalvat'">
                                      {{ fields.step1[which.key].saved ? 'mdi-check' : 'mdi-close' }}
                                    </v-icon>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <!-- <v-btn @click="removeFile('step1', which.key)" icon :disabled="!isDraft" title="Sterge fisier"> -->
                                  <v-btn @click="removeFile('step1', which.key)" icon :disabled="true" title="Sterge fisier">
                                    <v-icon color="error">mdi-delete</v-icon>
                                  </v-btn>
                                  <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </template>
                        </div>

                        <br>

                        <v-alert text color="info" border="left" icon="mdi-information">
                          <p style="text-align: justify">Atentie</p>
                          <p class="caption" style="text-align: justify">
                            Incarcarea fisierelor se face prin click sau drag&amp;drop pe casuta corespunzatoare.
                          </p>
                        </v-alert>

                        <v-btn
                          color="primary"
                          @click="stepper = 2"
                          text>
                          Spre Pasul 2</v-btn>
                      </v-stepper-content>

                      <v-stepper-step
                        id="pasul2"
                        :complete="step2Complete()"
                        step="2"
                        edit-icon="mdi-check"
                        editable
                        :rules="rulesStep2()">
                        Pasul 2
                        <small>Descriere succinta plan de afaceri</small>
                      </v-stepper-step>
                      <v-stepper-content step="2">
                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p style="text-align: justify">Mentioneaza in mod obligatoriu urmatoarele, conform planului de afaceri:</p>
                          <p class="caption" style="text-align: justify">
                            <ol type="a">
                              <li>Denumirea planului de afaceri</li>
                              <li>Sediul social</li>
                              <li>Activitate principala (CAEN)</li>
                              <li>Perioada de derulare a activitatilor pentru care se primeste subventia (obligatiu 18 luni)</li>
                              <li>Perioada de sustenabilitate (minimum 6 luni)</li>
                            </ol>
                          </p>
                        </v-alert>

                        <template v-for="field of text.step2">
                          <v-text-field
                            :key="field.key"
                            :label="field.label"
                            v-model="fields.step2[field.key]">
                          </v-text-field>
                        </template>

                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p class="caption" style="text-align: justify">
                            Incarca calendarul de activitati (pdf) (vezi model in Planul de afaceri – Anexa 5). Evidentiaza distinct lunile de proiect (18) si cele de sustenabilitate (minim 6, uterioare)
                          </p>
                        </v-alert>
                        <v-card style="display: inline-block; position: relative" class="ma-4 pa-0">
                          <v-card-text class="pa-0">
                            <v-card
                              width="200"
                              style="display: inline-block"
                              class="my-0"
                              elevation="0"
                              :color="drag.step2.file">
                              <div
                                @click="openFileUpload(`step2-file`)"
                                style="position: absolute; background-color: transparent; width: 200px; height: 100%; z-index: 1; cursor: pointer"
                                @dragover.prevent
                                @drop.prevent="addFile($event, 'step2', 'file')"
                                @dragenter.prevent="dragEnter($event, 'step2', 'file')"
                                @dragleave.prevent="dragLeave($event, 'step2', 'file')">
                              </div>

                              <input type="file" style="display: none" ref="step2-file" @change="addFile($event, 'step2', 'file')">

                              <v-img
                                class="white--text align-end"
                                height="100px"
                                :src="fields.step2.file.file || fields.step2.file.saved ? '/img/files_closed.jpg' : '/img/files_box_large.jpg'">
                              </v-img>
                              <v-card-subtitle class="text-center">
                                <span class="font-weight-bold" title="Click sau drag&amp;drop pentru a incarca un fisier">
                                  Calendarul de activitati
                                </span>
                                <br>
                                <span class="caption">{{ fields.step2.file.name }}</span>
                              </v-card-subtitle>

                              <v-divider></v-divider>
                            </v-card>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn icon :disabled="!fields.step2.file.saved" @click="downloadFile('step2', 'file')" title="Descarca fisier">
                              <v-icon color="primary">
                                mdi-download
                              </v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <span>
                              {{ (fields.step2.file.size / 1000).toFixed(2) }} KB
                              <v-icon small :color="fields.step2.file.saved ? 'primary' : 'grey'" :title="fields.step2.file.saved ? 'fisier salvat' : 'fisier nesalvat'">
                                {{ fields.step2.file.saved ? 'mdi-check' : 'mdi-close' }}
                              </v-icon>
                            </span>
                            <v-spacer></v-spacer>
                            <!-- <v-btn @click="removeFile('step2', 'file')" icon :disabled="!isDraft" title="Sterge fisier"> -->
                            <v-btn @click="removeFile('step2', 'file')" icon :disabled="true" title="Sterge fisier">
                              <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>

                        <br>

                        <v-alert text color="info" border="left" icon="mdi-information">
                          <p style="text-align: justify">Atentie</p>
                          <p class="caption" style="text-align: justify">
                            Incarcarea fisierelor se face prin click sau drag&amp;drop pe casuta corespunzatoare.
                          </p>
                        </v-alert>

                        <v-btn
                          @click="stepper = 1"
                          text>
                          Inapoi la Pasul 1
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="stepper = 3"
                          text>
                          Spre Pasul 3
                        </v-btn>
                      </v-stepper-content>

                      <v-stepper-step
                        id="pasul3"
                        :complete="step3Complete()"
                        step="3"
                        edit-icon="mdi-check"
                        editable
                        :rules="rulesStep3()">
                        Pasul 3
                        <small>Temele orizontale sau secundare la care contribuie intreprinderea, conform planului de afaceri</small>
                      </v-stepper-step>
                      <v-stepper-content step="3">
                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p style="text-align: justify">Mentioneaza in mod obligatoriu cel putin una dintre urmatoarele (se recomanda integrarea tuturor aspectelor de mai jos in planul de afaceri):</p>
                          <p class="caption" style="text-align: justify">
                            <ol type="a">
                              <li>Promovarea dezvoltarii durabile</li>
                              <li>Egalitatea de sanse</li>
                              <li>Reducerea emisiei de dioxid de carbon</li>
                              <li>Utilizarea TIC</li>
                              <li>Inovare sociala</li>
                              <li>Promovarea cercetari</li>
                            </ol>
                          </p>
                        </v-alert>

                        <template v-for="field of text.step3">
                          <!-- <v-text-field
                            :key="field.key"
                            :label="field.label"
                            v-model="fields.step3[field.key]">
                          </v-text-field> -->

                          <v-checkbox
                            class="ml-2"
                            v-model="fields.step3.selected"
                            :key="field.key"
                            :label="field.label"
                            :value="field.key">
                          </v-checkbox>
                        </template>

                        <br>

                        <v-btn
                          @click="stepper = 2"
                          text>
                          Inapoi la Pasul 2
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="stepper = 4"
                          text>
                          Spre Pasul 4
                        </v-btn>
                      </v-stepper-content>

                      <v-stepper-step
                        id="pasul4"
                        :complete="step4Complete()"
                        step="4"
                        edit-icon="mdi-check"
                        editable
                        :rules="rulesStep4()">
                        Pasul 4
                        <small>Asistenta financiara solicitata</small>
                      </v-stepper-step>
                      <v-stepper-content step="4">
                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p style="text-align: justify">Mentioneaza valoarea subventiei solicitate si contributia proprie (in lei) si incarca bugetul aferent subventiei (Anexa 6) atat in format xls cat si pdf:</p>
                        </v-alert>

                        <template v-for="field of text.step4">
                          <v-text-field
                            :key="field.key"
                            :label="field.label"
                            type="number"
                            suffix="RON"
                            v-model="fields.step4[field.key]">
                          </v-text-field>
                        </template>

                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p class="caption" style="text-align: justify">
                            Incarca bugetul aferent subventiei (Anexa 6) atat in format xls cat si pdf
                          </p>
                        </v-alert>

                        <div style="display: flex; flex-wrap: wrap; justify-content: space-around; align-items: stretch">
                          <template v-for="which in papers.step4">
                            <v-card :key="which.key" style="display: inline-block; position: relative" class="ma-4 pa-0">
                              <v-card-text class="pa-0">
                                <v-card
                                  :key="which.key"
                                  width="200"
                                  style="display: inline-block"
                                  class="ma-0"
                                  elevation="0"
                                  :color="drag.step4[which.key]">
                                  <div
                                    @click="openFileUpload(`step4-${which.key}`)"
                                    style="position: absolute; background-color: transparent; width: 200px; height: 100%; z-index: 1; cursor: pointer"
                                    @dragover.prevent
                                    @drop.prevent="addFile($event, 'step4', which.key)"
                                    @dragenter.prevent="dragEnter($event, 'step4', which.key)"
                                    @dragleave.prevent="dragLeave($event, 'step4', which.key)">
                                  </div>

                                  <input type="file" style="display: none" :ref="`step4-${which.key}`" @change="addFile($event, 'step4', which.key)">

                                  <v-img
                                    class="white--text align-end"
                                    height="100px"
                                    :src="fields.step4[which.key].file || fields.step4[which.key].saved ? '/img/files_closed.jpg' : '/img/files_box_large.jpg'">
                                  </v-img>
                                  <v-card-subtitle class="text-center">
                                    <span class="font-weight-bold" title="Click sau drag&amp;drop pentru a incarca un fisier">
                                      {{ which.label }}
                                    </span>
                                    <br>
                                    <span class="caption">{{ fields.step4[which.key].name }}</span>
                                  </v-card-subtitle>

                                  <v-divider></v-divider>
                                </v-card>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn icon :disabled="!fields.step4[which.key].saved" @click="downloadFile('step4', which.key)" title="Descarca fisier">
                                  <v-icon color="primary">
                                    mdi-download
                                  </v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <span>
                                  {{ (fields.step4[which.key].size / 1000).toFixed(2) }} KB
                                  <v-icon small :color="fields.step4[which.key].saved ? 'primary' : 'grey'" :title="fields.step4[which.key].saved ? 'fisier salvat' : 'fisier nesalvat'">
                                    {{ fields.step4[which.key].saved ? 'mdi-check' : 'mdi-close' }}
                                  </v-icon>
                                </span>
                                <v-spacer></v-spacer>
                                <!-- <v-btn @click="removeFile('step4', which.key)" icon :disabled="!isDraft" title="Sterge fisier"> -->
                                <v-btn @click="removeFile('step4', which.key)" icon :disabled="true" title="Sterge fisier">
                                  <v-icon color="error">mdi-delete</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </template>
                        </div>

                        <br>

                        <v-alert text color="info" border="left" icon="mdi-information">
                          <p style="text-align: justify">Atentie</p>
                          <p class="caption" style="text-align: justify">
                            Incarcarea fisierelor se face prin click sau drag&amp;drop pe casuta corespunzatoare.
                          </p>
                        </v-alert>

                        <v-btn
                          @click="stepper = 3"
                          text>
                          Inapoi la Pasul 3
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="stepper = 5"
                          text>
                          Spre Pasul 5
                        </v-btn>
                      </v-stepper-content>

                      <v-stepper-step
                        id="pasul5"
                        :complete="step5Complete()"
                        step="5"
                        edit-icon="mdi-check"
                        editable
                        :rules="rulesStep5()">
                        Pasul 5
                        <small>Numarul de angajati si fisele de post</small>
                      </v-stepper-step>
                      <v-stepper-content step="5">
                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p style="text-align: justify">Mentioneaza numarul de angajati si norma de lucru, conform planului de afaceri</p>
                          <p class="caption" style="text-align: justify">
                            Atentie! Coreleaza numarul minim de angajati cu valoarea subventiei solicitate, conform Metodologiei.
                            Descrie pentru fiecare post: norma de munca (partiala/totala), numarul de ore pe luna, numarul total de ore, asa cum este trecut in fisele de post.
                          </p>
                        </v-alert>

                        <v-textarea
                          solo
                          outlined
                          flat
                          auto-grow
                          rows="6"
                          class="mb-12"
                          v-model="fields.step5.text"
                          placeholder="Mentioneaza numarul de angajati, conform planului de afaceri.">
                        </v-textarea>

                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p class="caption" style="text-align: justify">
                            Anexeaza un pdf continand fisele de post (vezi model Fise de post in Planul de afaceri – Anexa 5).
                          </p>
                        </v-alert>

                        <v-card style="display: inline-block; position: relative" class="ma-4 pa-0">
                          <v-card-text class="pa-0">
                            <v-card
                              width="200"
                              style="display: inline-block"
                              class="my-0"
                              elevation="0"
                              :color="drag.step5.file">

                              <div
                                @click="openFileUpload(`step5-file`)"
                                style="position: absolute; background-color: transparent; width: 200px; height: 100%; z-index: 1; cursor: pointer"
                                @dragover.prevent
                                @drop.prevent="addFile($event, 'step5', 'file')"
                                @dragenter.prevent="dragEnter($event, 'step5', 'file')"
                                @dragleave.prevent="dragLeave($event, 'step5', 'file')">
                              </div>

                              <input type="file" style="display: none" ref="step5-file" @change="addFile($event, 'step5', 'file')">

                              <v-img
                                class="white--text align-end"
                                height="100px"
                                :src="fields.step5.file.file || fields.step5.file.saved ? '/img/files_closed.jpg' : '/img/files_box_large.jpg'">
                              </v-img>
                              <v-card-subtitle class="text-center">
                                <span class="font-weight-bold" title="Click sau drag&amp;drop pentru a incarca un fisier">
                                  Fisele de post
                                </span>
                                <br>
                                <span class="caption">{{ fields.step5.file.name }}</span>
                              </v-card-subtitle>

                              <v-divider></v-divider>
                            </v-card>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn icon :disabled="!fields.step5.file.saved" @click="downloadFile('step5', 'file')" title="Descarca fisier">
                              <v-icon color="primary">
                                mdi-download
                              </v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <span>
                              {{ (fields.step5.file.size / 1000).toFixed(2) }} KB
                              <v-icon small :color="fields.step5.file.saved ? 'primary' : 'grey'" :title="fields.step5.file.saved ? 'fisier salvat' : 'fisier nesalvat'">
                                {{ fields.step5.file.saved ? 'mdi-check' : 'mdi-close' }}
                              </v-icon>
                            </span>
                            <v-spacer></v-spacer>
                            <!-- <v-btn @click="removeFile('step5', 'file')" icon :disabled="!isDraft" title="Sterge fisier"> -->
                            <v-btn @click="removeFile('step5', 'file')" icon :disabled="true" title="Sterge fisier">
                              <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>

                        <br>

                        <v-alert text color="info" border="left" icon="mdi-information">
                          <p style="text-align: justify">Atentie</p>
                          <p class="caption" style="text-align: justify">
                            Incarcarea fisierelor se face prin click sau drag&amp;drop pe casuta corespunzatoare.
                          </p>
                        </v-alert>

                        <v-btn
                          @click="stepper = 4"
                          text>
                          Inapoi la Pasul 4
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="stepper = 6"
                          text>
                          Spre Pasul 6
                        </v-btn>
                      </v-stepper-content>

                      <v-stepper-step
                        id="pasul6"
                        :complete="step6Complete()"
                        step="6"
                        edit-icon="mdi-check"
                        editable
                        :rules="rulesStep6()">
                        Pasul 6
                        <small>Incarca planul de afaceri (document pdf) – Anexa 5; Incarca si Buget - Sectiunile 7.1, 7.2 si 7.3 din Planul de afaceri in format xls.</small>
                      </v-stepper-step>
                      <v-stepper-content step="6">
                        <v-alert text color="primary" border="left" icon="mdi-information">
                          <p class="caption" style="text-align: justify">
                            Planul de afaceri (document pdf) – Anexa 5. <br>
                            Buget - Sectiunile 7.1, 7.2 si 7.3 din Planul de afaceri (document xls)
                          </p>
                        </v-alert>

                        <div style="display: flex; flex-wrap: wrap; justify-content: space-around; align-items: stretch">
                          <v-card style="display: inline-block; position: relative" class="ma-4 pa-0">
                            <v-card-text class="pa-0">
                              <v-card
                                width="200"
                                style="display: inline-block"
                                class="ma-0"
                                elevation="0"
                                :color="drag.step6.file">

                                <div
                                  @click="openFileUpload(`step6-file`)"
                                  style="position: absolute; background-color: transparent; width: 200px; height: 100%; z-index: 1; cursor: pointer"
                                  @dragover.prevent
                                  @drop.prevent="addFile($event, 'step6', 'file')"
                                  @dragenter.prevent="dragEnter($event, 'step6', 'file')"
                                  @dragleave.prevent="dragLeave($event, 'step6', 'file')">
                                </div>

                                <input type="file" style="display: none" ref="step6-file" @change="addFile($event, 'step6', 'file')">

                                <v-img
                                  class="white--text align-end"
                                  height="100px"
                                  :src="fields.step6.file.file || fields.step6.file.saved ? '/img/files_closed.jpg' : '/img/files_box_large.jpg'">
                                </v-img>
                                <v-card-subtitle class="text-center">
                                  <span class="font-weight-bold" title="Click sau drag&amp;drop pentru a incarca un fisier">
                                    Planul de afaceri (pdf)
                                  </span>
                                  <br>
                                  <span class="caption">{{ fields.step6.file.name }}</span>
                                </v-card-subtitle>

                                <v-divider></v-divider>
                              </v-card>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn icon :disabled="!fields.step6.file.saved" @click="downloadFile('step6', 'file')" title="Descarca fisier">
                                <v-icon color="primary">
                                  mdi-download
                                </v-icon>
                              </v-btn>
                              <v-spacer></v-spacer>
                              <span>
                                {{ (fields.step6.file.size / 1000).toFixed(2) }} KB
                                <v-icon small :color="fields.step6.file.saved ? 'primary' : 'grey'" :title="fields.step6.file.saved ? 'fisier salvat' : 'fisier nesalvat'">
                                  {{ fields.step6.file.saved ? 'mdi-check' : 'mdi-close' }}
                                </v-icon>
                              </span>
                              <v-spacer></v-spacer>
                              <!-- <v-btn @click="removeFile('step6', 'file')" icon :disabled="!isDraft" title="Sterge fisier"> -->
                              <v-btn @click="removeFile('step6', 'file')" icon :disabled="true" title="Sterge fisier">
                                <v-icon color="error">mdi-delete</v-icon>
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>

                          <v-card style="display: inline-block; position: relative" class="ma-4 pa-0">
                            <v-card-text class="pa-0">
                              <v-card
                                width="200"
                                style="display: inline-block"
                                class="ma-0"
                                elevation="0"
                                :color="drag.step6.anotherfile">

                                <div
                                  @click="openFileUpload(`step6-anotherfile`)"
                                  style="position: absolute; background-color: transparent; width: 200px; height: 100%; z-index: 1; cursor: pointer"
                                  @dragover.prevent
                                  @drop.prevent="addFile($event, 'step6', 'anotherfile')"
                                  @dragenter.prevent="dragEnter($event, 'step6', 'anotherfile')"
                                  @dragleave.prevent="dragLeave($event, 'step6', 'anotherfile')">
                                </div>

                                <input type="file" style="display: none" ref="step6-anotherfile" @change="addFile($event, 'step6', 'anotherfile')">

                                <v-img
                                  class="white--text align-end"
                                  height="100px"
                                  :src="fields.step6.anotherfile.file || fields.step6.anotherfile.saved ? '/img/files_closed.jpg' : '/img/files_box_large.jpg'">
                                </v-img>
                                <v-card-subtitle class="text-center">
                                  <span class="font-weight-bold" title="Click sau drag&amp;drop pentru a incarca un fisier">
                                    Buget (xls)
                                  </span>
                                  <br>
                                  <span class="caption">{{ fields.step6.anotherfile.name }}</span>
                                </v-card-subtitle>

                                <v-divider></v-divider>
                              </v-card>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn icon :disabled="!fields.step6.anotherfile.saved" @click="downloadFile('step6', 'anotherfile')" title="Descarca fisier">
                                <v-icon color="primary">
                                  mdi-download
                                </v-icon>
                              </v-btn>
                              <v-spacer></v-spacer>
                              <span>
                                {{ (fields.step6.anotherfile.size / 1000).toFixed(2) }} KB
                                <v-icon small :color="fields.step6.anotherfile.saved ? 'primary' : 'grey'" :title="fields.step6.anotherfile.saved ? 'fisier salvat' : 'fisier nesalvat'">
                                  {{ fields.step6.anotherfile.saved ? 'mdi-check' : 'mdi-close' }}
                                </v-icon>
                              </span>
                              <v-spacer></v-spacer>
                              <!-- <v-btn @click="removeFile('step6', 'anotherfile')" icon :disabled="!isDraft" title="Sterge fisier"> -->
                              <v-btn @click="removeFile('step6', 'anotherfile')" icon :disabled="true" title="Sterge fisier">
                                <v-icon color="error">mdi-delete</v-icon>
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </div>

                        <br>

                        <v-alert text color="info" border="left" icon="mdi-information">
                          <p style="text-align: justify">Atentie</p>
                          <p class="caption" style="text-align: justify">
                            Incarcarea fisierelor se face prin click sau drag&amp;drop pe casuta corespunzatoare.
                          </p>
                        </v-alert>

                        <v-btn
                          @click="stepper = 5"
                          text>
                          Inapoi la Pasul 5
                        </v-btn>
                      </v-stepper-content>
                    </v-stepper>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="primary" :disabled="!allValidSteps()" v-if="isDraft" :loading="loading" @click="showConfirm">Depunere</v-btn> -->
                    <v-btn color="primary" :disabled="true" v-if="isDraft" :loading="loading" @click="showConfirm">Depunere</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-col>
    </v-row>

    <v-dialog v-model="depunereAlert" width="750">
      <v-card>
        <v-card-title>
          Atentie!
        </v-card-title>
        <v-card-text>
          <v-alert type="warning" border="left" prominent text class="text-justify">
            Prin apasarea butonului Depunere aplicatia ta se finalizeaza si nu vei mai putea realiza modificari ulterioare. Esti sigur ca vrei sa apesi Depunere?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="depunereAlert = false">
            Nu, mai vreau sa modific
          </v-btn>
          <v-btn color="primary" @click="confirmDepunere">
            Da, am terminat, vreau sa depun
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="depunereConfirmation" width="600">
      <v-card>
        <v-card-title>
          Felicitari
        </v-card-title>
        <v-card-text class="text-body-1">
          Aplicatia ta a fost inregistrata cu nr.
          <strong>{{ user.nrcrt }}</strong>
          din
          <strong>
            {{ lastSave ? new Date(lastSave).toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }) : "" }}.
          </strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="depunereConfirmation = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "form-component",

  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    user() {
      return this.$store.getters.user;
    },
    personal() {
      return this.$store.getters.personal;
    },
    completedPersonal() {
      return !!this.personal.nume &&
             !!this.personal.prenume &&
             !!this.personal.judet &&
             !!this.personal.cnp &&
             !!this.personal.hasCert &&
             !!this.personal.certUrl &&
             Array.isArray(this.personal.ciUrl) &&
             !!this.personal.ciUrl.length;
    },
    freeOfErrors() {
      return item => {
        return [
          () => {
            if (this.$refs && this.$refs[`ref-${item.step}`]) {
              if (this.$refs[`ref-${item.step}`][0].hasFocused || this.editingDraft) {
                return !this.$refs[`ref-${item.step}`][0].hasError;
              } else {
                return true;
              }
            } else {
              return true;
            }
          }
        ];
      };
    },
    getProgressColor() {
      // just because of Drewfus
      if (this.autoSavePercentage < 35) return "info";
      if (this.autoSavePercentage < 70) return "warning";
      return "error";
    }
  },

  data() {
    return {
      depunereConfirmation: false,
      depunereAlert: false,
      tab: 0,
      alert: true,
      validForm: true,
      stepper: 1,
      text: {
        step2: [
          { key: 'denumire', label: 'a) Denumirea planului de afaceri' },
          { key: 'sediu', label: 'b) Sediul social' },
          { key: 'activitate', label: 'c) Activitate principala (CAEN)' },
          { key: 'derulare', label: 'd) Perioada de derulare a activitatilor pentru care se primeste subventia (mentioneaza obligatoriu 18 luni)' },
          { key: 'sustenabilitate', label: 'e) Perioada de sustenabilitate (minimum 6 luni)' }
        ],
        step3: [
          { key: 'dezvoltare', label: 'a) Promovarea dezvoltarii durabile' },
          { key: 'egalitate', label: 'b) Egalitatea de sanse' },
          { key: 'co2', label: 'c) Reducerea emisiei de dioxid de carbon' },
          { key: 'tic', label: 'd) Utilizarea TIC' },
          { key: 'inovare', label: 'e) Inovare sociala' },
          { key: 'cercetare', label: 'f) Promovarea cercetarii' }
        ],
        step4: [
          { key: 'subventie', label: 'Valoarea subventiei solicitate' },
          { key: 'contributie', label: 'Contributia proprie' }
        ]
      },
      papers: {
        step1: [
          { key: 'cerere', label: 'Cerere tip' },
          { key: 'declaratie', label: 'Declaratia de eligibilitate' },
          { key: 'cazierjudiciar', label: 'Cazier judiciar' },
          { key: 'cazierfiscal', label: 'Cazier fiscal' },
          { key: 'cv', label: 'CV' }
        ],
        step2: [
          { key: 'pdf', label: 'Calendarul de activitati' }
        ],
        step4: [
          { key: 'xls', label: 'Bugetul aferent subventiei (xls)' },
          { key: 'pdf', label: 'Bugetul aferent subventiei (pdf)' }
        ]
      },
      drag: {
        step1: {
          cerere: "white",
          declaratie: "white",
          cazierjudiciar: "white",
          cazierfiscal: "white",
          cv: "white"
        },
        step2: {
          pdf: "white"
        },
        step4: {
          xls: "white",
          pdf: "white"
        },
        step5: {
          pdf: "white"
        },
        step6: {
          file: "white",
          anotherfile: "white"
        }
      },
      fields: {
        step1: {
          cerere: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          },
          declaratie: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          },
          cazierjudiciar: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          },
          cazierfiscal: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          },
          cv: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          }
        },
        step2: {
          denumire: '',
          sediu: '',
          activitate: '',
          derulare: '',
          sustenabilitate: '',
          file: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          }
        },
        step3: {
          selected: ['placeholder']
        },
        step4: {
          subventie: '',
          contributie: '',
          xls: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          },
          pdf: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          }
        },
        step5: {
          text: '',
          file: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          }
        },
        step6: {
          file: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          },
          anotherfile: {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          }
        }
      },
      autoSavePercentage: 0,
      autoSaveTimer: null,
      autoSaveInterval: 60,
      lastSave: null,
      editingDraft: false,
      isDraft: false
    };
  },

  watch: {
    // loading(value) {
    //   if (value) {
    //     clearInterval(this.autoSaveTimer);
    //     this.autoSavePercentage = 0;
    //   } else {
    //     this.setAutoSave();
    //   }
    // },
    stepper(value) {
      setTimeout(() => {
        this.$vuetify.goTo(`#pasul${value}`, {
          duration: 300,
          offset: this.alert ? 270 : 70,
          easing: "easeInOutCubic"
        });
      }, 500);
    }
  },

  methods: {
    removeFile(step, key) {
      this.fields[step][key] = {
        name: '',
        size: 0,
        saved: false,
        url: '',
        file: null
      };
    },
    allValidSteps() {
      return this.step1Complete() &&
            this.step2Complete() &&
            this.step3Complete() &&
            this.step4Complete() &&
            this.step5Complete() &&
            this.step6Complete() &&
            this.completedPersonal;
    },
    step1Complete () {
      return this.lastSave ? (!!this.fields.step1.cerere.file || (!!this.fields.step1.cerere.saved && !!this.fields.step1.cerere.url)) &&
        (!!this.fields.step1.declaratie.file || (!!this.fields.step1.declaratie.saved && !!this.fields.step1.declaratie.url)) &&
        (!!this.fields.step1.cazierjudiciar.file || (!!this.fields.step1.cazierjudiciar.saved && !!this.fields.step1.cazierjudiciar.url)) &&
        (!!this.fields.step1.cazierfiscal.file || (!!this.fields.step1.cazierfiscal.saved && !!this.fields.step1.cazierfiscal.url)) &&
        (!!this.fields.step1.cv.file || (!!this.fields.step1.cv.saved && !!this.fields.step1.cv.url)) : false;
    },
    rulesStep1 () {
      return [
        () => this.lastSave ? this.step1Complete() : true
      ]
    },
    step2Complete () {
      return this.lastSave ? (!!this.fields.step2.file.file || (!!this.fields.step2.file.saved && !!this.fields.step2.file.url)) &&
        !!this.fields.step2.denumire &&
        !!this.fields.step2.sediu &&
        !!this.fields.step2.activitate &&
        !!this.fields.step2.derulare &&
        !!this.fields.step2.sustenabilitate : false;
    },
    rulesStep2 () {
      return [
        () => this.lastSave ? this.step2Complete() : true
      ]
    },
    step3Complete () {
      return this.lastSave ? this.fields.step3.selected.length > 1 : false;
    },
    rulesStep3 () {
      return [
        () => this.lastSave ? this.step3Complete() : true
      ]
    },
    step4Complete () {
      return this.lastSave ? !!this.fields.step4.subventie &&
      !!this.fields.step4.contributie &&
      (!!this.fields.step4.xls.file || (!!this.fields.step4.xls.saved && !!this.fields.step4.xls.url)) &&
      (!!this.fields.step4.pdf.file || (!!this.fields.step4.pdf.saved && !!this.fields.step4.pdf.url)) : false;
    },
    rulesStep4 () {
      return [
        () => this.lastSave ? this.step4Complete() : true
      ]
    },
    step5Complete () {
      return this.lastSave ? !!this.fields.step5.text &&
      (!!this.fields.step5.file.file || (!!this.fields.step5.file.saved && !!this.fields.step5.file.url)) : false;
    },
    rulesStep5 () {
      return [
        () => this.lastSave ? this.step5Complete() : true
      ]
    },
    step6Complete () {
      return this.lastSave ? (!!this.fields.step6.file.file || (!!this.fields.step6.file.saved && !!this.fields.step6.file.url) && (!!this.fields.step6.anotherfile.file || (!!this.fields.step6.anotherfile.saved && !!this.fields.step6.anotherfile.url))) : false;
    },
    rulesStep6 () {
      return [
        () => this.lastSave ? this.step6Complete() : true
      ]
    },

    async saveForm ($event, draft = false) {
      /* eslint-disable no-unreachable */
      return;
      // $event is here because "Depune" is submitting the form
      this.lastSave = new Date();
      if (!draft) {
        clearInterval(this.autoSaveTimer);
        this.autoSavePercentage = 0;
      }
      await this.$store.dispatch("saveForm", { ...this.fields,  draft, lastSave: this.lastSave });

      if (!draft) {
        this.getDraft();
        this.depunereConfirmation = true;
      }
    },

    showConfirm () {
      this.depunereAlert = true;
    },
    confirmDepunere () {
      this.depunereAlert = false;
      this.saveForm(null, false);
    },

    openFileUpload (ref) {
      /* eslint-disable no-unreachable */
      return;
      if (!this.isDraft) return;
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    addFile ($event, step, which) {
      /* eslint-disable no-unreachable */
      return;
      if (!this.isDraft) {
        this.drag[step][which] = "white";
        return;
      }
      // only get the first file no matter how many are dropped/picked
      if ($event.dataTransfer) { // file! dropped
        if ($event.dataTransfer.files.length) {
          this.drag[step][which] = "white";
          if (step === 'step2') {
            if (!$event.dataTransfer.files[0].type.includes('pdf')) return;
          }
          if (step === 'step4' && which === 'pdf') {
            if (!$event.dataTransfer.files[0].type.includes('pdf')) return;
          }
          // if (step === 'step4' && which === 'xls') {
          //   if (
          //     !$event.dataTransfer.files[0].type.includes('xls') &&
          //     !$event.dataTransfer.files[0].type.includes('xlsx') &&
          //     !$event.dataTransfer.files[0].type.includes('sheet') &&
          //     !$event.dataTransfer.files[0].type.includes('excel')
          //   ) return;
          // }
          if (step === 'step5') {
            if (!$event.dataTransfer.files[0].type.includes('pdf')) return;
          }
          if (step === 'step6' && which === 'file') {
            if (!$event.dataTransfer.files[0].type.includes('pdf')) return;
          }
          // if (step === 'step6' && which === 'anotherfile') {
          //   if (
          //     !$event.dataTransfer.files[0].type.includes('xls') &&
          //     !$event.dataTransfer.files[0].type.includes('xlsx') &&
          //     !$event.dataTransfer.files[0].type.includes('sheet') &&
          //     !$event.dataTransfer.files[0].type.includes('excel')
          //   ) return;
          // }
          this.fields[step][which].file = $event.dataTransfer.files[0];
          this.fields[step][which].name = $event.dataTransfer.files[0].name;
          this.fields[step][which].size = $event.dataTransfer.files[0].size;
          this.fields[step][which].saved = false;
        }
      } else {
        if ($event.target.files.length) {
          this.drag[step][which] = "white";
          if (step === 'step2') {
            if (!$event.target.files[0].type.includes('pdf')) return;
          }
          if (step === 'step4' && which === 'pdf') {
            if (!$event.target.files[0].type.includes('pdf')) return;
          }
          // if (step === 'step4' && which === 'xls') {
          //   if (
          //     !$event.target.files[0].type.includes('xls') &&
          //     !$event.target.files[0].type.includes('xlsx') &&
          //     !$event.target.files[0].type.includes('sheet') &&
          //     !$event.target.files[0].type.includes('excel')
          //   ) return;
          // }
          if (step === 'step5') {
            if (!$event.target.files[0].type.includes('pdf')) return;
          }
          if (step === 'step6' && which === 'file') {
            if (!$event.target.files[0].type.includes('pdf')) return;
          }
          // if (step === 'step6' && which === 'anotherfile') {
          //   if (
          //     !$event.target.files[0].type.includes('xls') &&
          //     !$event.target.files[0].type.includes('xlsx') &&
          //     !$event.target.files[0].type.includes('sheet') &&
          //     !$event.target.files[0].type.includes('excel')
          //   ) return;
          // }
          this.fields[step][which].file = $event.target.files[0];
          this.fields[step][which].name = $event.target.files[0].name;
          this.fields[step][which].size = $event.target.files[0].size;
          this.fields[step][which].saved = false;
        }
      }

      const ref = `${step}-${which}`;
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].value = null;
      } else {
        this.$refs[ref].value = null;
      }
    },

    dragEnter ($event, step, which) {
      /* eslint-disable no-unreachable */
      return;
      this.drag[step][which] = "green lighten-4";

      if (step === 'step2') {
        if (!$event.dataTransfer.items[0].type.includes('pdf')) this.drag[step][which] = "red lighten-4";
      }
      if (step === 'step4' && which === 'pdf') {
        if (!$event.dataTransfer.items[0].type.includes('pdf')) this.drag[step][which] = "red lighten-4";
      }
      if (step === 'step4' && which === 'xls') {
        if (
          !$event.dataTransfer.items[0].type.includes('xls') &&
          !$event.dataTransfer.items[0].type.includes('xlsx') &&
          !$event.dataTransfer.items[0].type.includes('sheet') &&
          !$event.dataTransfer.items[0].type.includes('excel')
        ) this.drag[step][which] = "red lighten-4";
      }
      if (step === 'step5') {
        if (!$event.dataTransfer.items[0].type.includes('pdf')) this.drag[step][which] = "red lighten-4";
      }
      if (step === 'step6' && which === 'file') {
        if (!$event.dataTransfer.items[0].type.includes('pdf')) this.drag[step][which] = "red lighten-4";
      }
      if (step === 'step6' && which === 'anotherfile') {
        if (
          !$event.dataTransfer.items[0].type.includes('xls') &&
          !$event.dataTransfer.items[0].type.includes('xlsx') &&
          !$event.dataTransfer.items[0].type.includes('sheet') &&
          !$event.dataTransfer.items[0].type.includes('excel')
        ) this.drag[step][which] = "red lighten-4";
      }
    },
    dragLeave ($event, field, which) {
      /* eslint-disable no-unreachable */
      return;
      this.drag[field][which] = "white";
    },

    downloadFile(step, which) {
      const link = document.createElement("a");
      link.href = this.fields[step][which].url;
      link.download = this.fields[step][which].name;
      link.target = "_blank";
      link.click();
      link.remove();
    },

    autoSave() {
      if (!this.loading) {
        this.saveForm(null, true);
      }
    },

    setAutoSave() {
      clearInterval(this.autoSaveTimer)
      this.autoSaveTimer = setInterval(() => {
        if (this.autoSavePercentage >= 100) {
          this.autoSavePercentage = 0;
          this.autoSave();
        } else {
          const s = (this.autoSavePercentage * this.autoSaveInterval) / 100 + 1;
          this.autoSavePercentage = (s * 100) / this.autoSaveInterval;
        }
      }, 1000);
    },

    async getDraft() {
      /* eslint-disable no-unused-vars */
      const fbResult = await this.$store.dispatch("fetchDraft");

      if (fbResult) {
        const { draft, lastSave, ...data } = fbResult;

        this.isDraft = draft;

        if (!this.isDraft) {
          clearInterval(this.autoSaveTimer);
        }

        this.editingDraft = true;

        this.lastSave = lastSave || null;


        // hack because firebase doesn't save nulls
        //  step1: cerere, declaratie, cazierjudiciar, cazierfiscal, cv
        //  step2: file
        //  step4: xls, pdf
        //  step5: file
        //  step6: file

        data.step1.cerere.file = null
        data.step1.declaratie.file = null
        data.step1.cazierjudiciar.file = null
        data.step1.cazierfiscal.file = null
        data.step1.cv.file = null

        data.step2.file.file = null

        data.step4.xls.file = null
        data.step4.pdf.file = null

        data.step5.file.file = null

        data.step6.file.file = null
        if (data.step6.anotherfile) {
          data.step6.anotherfile.file = null
        } else {
          data.step6.anotherfile = {
            name: '',
            size: 0,
            saved: false,
            url: '',
            file: null
          }
        }

        if (!data.step3.selected) {
          delete data.step3;
          data.step3 = {
            selected: ['placeholder']
          };
        }

        this.fields = Object.assign({}, this.fields, data);

        this.$nextTick(() => {
          this.$refs.form.validate();
        })
      } else {
        this.isDraft = true;
      }
    }
  },

  async mounted() {
    this.getDraft();

    // this.setAutoSave();
  },

  beforeDestroy() {
    clearInterval(this.autoSaveTimer);
  }
};

</script>
